import type { TokenPair } from '../types/api';
import { apiPublicRequest, apiRequest } from './client';

export async function requestOtp(body: { email?: string; phone?: string }): Promise<void> {
    await apiPublicRequest('/authentication/login', {
        method: 'POST',
        body: JSON.stringify(body),
    });
}

export async function verifyOtp(body: {
    email?: string;
    phone?: string;
    otp: string;
}): Promise<TokenPair> {
    return apiPublicRequest<TokenPair>('/authentication/verify-otp', {
        method: 'POST',
        body: JSON.stringify(body),
    });
}

/** Best-effort server-side session revoke; never throws so logout always clears locally. */
export async function logoutApi(): Promise<void> {
    try {
        await apiRequest<void>('/authentication/logout', { method: 'POST' });
    } catch {
        /* ignore — local token clear is the source of truth for the UI */
    }
}
